import React from "react";
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { Col, Card } from "react-bootstrap";
import CurrenyFormat from '../../../Helpers/Formatters/CurrencyFormat'

import '../../Quoter.scss';

export default function QuoteCardOption(props) {
    return (
        <Col sm={6} md={4} className="d-flex">
            <label hidden={true} id={`option-${props.id}`}>{props.product} {props.term}-Year Term Length Option</label>
            <Card className="card-border flex-fill mx-auto" aria-labelledby={`option-${props.id}`}>
                <Card.Body className="p-3">
                    <div className="d-flex flex-column align-items-left">
                        <div className="in-card-term mb-2">{props.term}-Year Term</div>
                        <img className="carrier-logo" src={props.logoUrl} alt={`${props.carrierName} Logo`} width="100" />
                        <div className="card-rate">
                            <CurrenyFormat className="quote-amount-dollars card-rate" removeSymbol number={props.monthlyRate && parseFloat(props.monthlyRate.toFixed(2))} /> /mo
                        </div>
                        <Button variant="contained" className="alignButton" onClick={() => props.getQuote(props.carrierName)}>GET A QUOTE</Button>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    )
}

QuoteCardOption.propTypes ={
    id: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
    term: PropTypes.number.isRequired,
    logoUrl: PropTypes.string.isRequired,
    carrierName: PropTypes.string.isRequired,
    monthlyRate: PropTypes.number
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/QuoteCardOption.js